<template>
  <v-ons-page id="products-page" class="option2 page-column">
    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button>
        </v-ons-back-button>
      </div>
      <div class="center">Products</div>
    </v-ons-toolbar>

    <div class="flex-column flex-grow">
      <div style="width: 100%">
        <v-ons-card @click="pushProduct(type)" v-for="type in types" :key="type.title" class="flex-row">
          <div class="thumbnail background-cover" :class="type.class"></div>
          <div class="title">
            <span>{{ type.title }}</span>
          </div>
        </v-ons-card>
        <v-ons-card @click="pushFavorites()" class="flex-row">
          <div class="thumbnail" style="background: #000">
            <i class="fa fa-star" style="font-size: 35px; padding-top: 14px"></i>
          </div>
          <div class="title">
            <span>Favorites</span>
          </div>
        </v-ons-card>
      </div>
    </div>

  </v-ons-page>
</template>

<script>
import Filters from '../../components/Filters.vue'
import Favorites from '../../components/Favorites.vue'
import { appData } from '../../data.js'

export default {
  name: 'products',
  props: {

  },
  data () {
    return {
      types: appData.state.types,
      Filters: Filters
    }
  },
  methods: {
    pushProduct(type) {
      this.$emit('push-page', {
        extends: Filters,
        onsNavigatorProps: {
          type: type
        }
      });
    },
    pushFavorites(type) {
      this.$emit('push-page', {
        extends: Favorites,
        onsNavigatorProps: {
        }
      });
    },
  },
  created() {

  }
}
</script>

<style scoped>
  * {
    box-sizing: border-box;
  }

  ons-card {
    text-align: center;
    display: flex;
    flex-direction: column;
    flex-direction: row;
    margin: 22px;
  }

  ons-card img {
    width: 100%;
  }

  ons-card > * {
    font-size: 20px;
  }

  .thumbnail {
    width: 67px;
    height: 67px;
  }

  .background-cover {
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
  }

  ons-card .title {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .title {
    text-align: left;
    padding-left: 28px;
    text-transform: uppercase;
    margin: 4px 0 4px 0;
  }
</style>



// WEBPACK FOOTER //
// src/Option2/components/Products.vue